import React, { useState, useRef, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import LanguageContext from 'src/utils/context/LanguageContext';
import { setLanguage } from 'src/utils/data/i18n';
import getEnv from 'src/utils/api/env';
import s from './LanguageSelect.styles';

const LanguageSelect = props => {
  const { i18n } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  const ref = useRef(null);
  useEffect(() => {
    const handleClickOutside = e => {
      if (ref.current && !ref.current.contains(e.target)) {
        setExpanded(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);

  const { onLanguageChange } = useContext(LanguageContext);

  const changeLanguage = language => {
    i18n.changeLanguage(language, () => {
      setLanguage(language);
      onLanguageChange();
      setExpanded(false);
    });
  };

  const languages = {
    'en': {
      full: 'English',
      short: 'EN',
    },
    'cn': {
      full: '中文',
      short: '中文',
    },
    'test': {
      full: 'Test',
      short: 'TEST',
    },
  };

  return (
    <s.Menu expanded={props.expanded}>
      <s.Item onClick={() => setExpanded(true)} selected={expanded}>
        <s.Icon name="language" />
      </s.Item>
      {expanded && (
        <s.SelectWrapper ref={ref}>
          <s.Language
            onClick={() => changeLanguage('en')}
            selected={i18n.language === 'en'}
          >
            {languages.en.full}
          </s.Language>
          <s.Language
            onClick={() => changeLanguage('cn')}
            selected={i18n.language === 'cn'}
          >
            {languages.cn.full}
          </s.Language>
          {['LOCAL', 'DEV'].includes(getEnv()) && (
            <s.Language
              onClick={() => changeLanguage('test')}
              selected={i18n.language === 'test'}
            >
              {languages.test.full}
            </s.Language>
          )}
        </s.SelectWrapper>
      )}
    </s.Menu>
  );
};

LanguageSelect.propTypes = {
  expanded: PropTypes.bool,
};

export default React.memo(LanguageSelect);
